<template>
  <main-layout>
    <h1 class="title">Ricerca azioni marketing</h1>

    <b-field horizontal grouped label="Data azione (da/a)">
      <datepicker v-model="dateRangeAfter" required></datepicker>
      <datepicker v-model="dateRangeBefore" required></datepicker>
    </b-field>

    <b-field horizontal grouped label="Data azione successiva (da/a)">
      <datepicker v-model="nextActionRangeAfter" required></datepicker>
      <datepicker v-model="nextActionRangeBefore" required></datepicker>
    </b-field>

    <b-field
      v-if="
        (nextActionRangeAfter && nextActionRangeBefore) ||
        (dateRangeAfter && dateRangeBefore)
      "
      grouped
      horizontal
      style="margin-bottom: 30px"
      message="In base alla quantità di risultati, la ricerca potrebbe impiegare alcuni secondi. Premere Cerca una sola volta e attendere."
    >
      <p class="control">
        <button
          class="button is-success"
          style="margin-right: 15px"
          @click="fetch()"
        >
          Cerca
        </button>
        <button class="button" @click="clean()">Pulisci</button>
      </p>
    </b-field>

    <div style="position: relative; min-height: 400px">
      <b-table
        v-if="results"
        striped
        :data="results"
        :loading="loading"
        :total="results.count"
        backend-sorting
        :default-sort="['id', 'desc']"
        @sort="onSort"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="ID" width="40" sortable numeric>
            {{ props.row.id }}
          </b-table-column>

          <b-table-column field="customer_name" label="Cliente" sortable>
            <b>
              <router-link
                :to="{
                  name: 'customers.show',
                  params: { id: props.row.customer },
                }"
              >
                {{ props.row.customer_name }}
              </router-link>
            </b>
          </b-table-column>

          <b-table-column
            field="customer_prospect_display"
            label="Tipo Cliente"
            sortable
          >
            {{ props.row.customer_prospect_display || "N/A" }}
          </b-table-column>

          <b-table-column field="date" label="Data azione" sortable>
            {{ props.row.date }}
          </b-table-column>

          <b-table-column field="action" label="Azione" sortable>
            {{ props.row.action }}
          </b-table-column>

          <b-table-column field="description" label="Descrizione" sortable>
            {{ props.row.description }}
          </b-table-column>

          <b-table-column field="notes" label="Note" sortable>
            {{ props.row.notes }}
          </b-table-column>

          <b-table-column
            field="next_action"
            label="Azione successiva"
            sortable
          >
            {{ props.row.next_action }}
          </b-table-column>
        </template>
        <template slot="footer">
          <download-csv
            class="button is-default"
            :data="results"
            name="data.csv"
            delimiter=";"
          >
            <b-icon icon="table"></b-icon>
            <span>CSV</span>
          </download-csv>
        </template>
      </b-table>
      <b-loading :is-full-page="false" :active.sync="loading"></b-loading>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/Main"
import MarketingActionProxy from "@/proxies/MarketingActionProxy"

export default {
  name: "MarketingActionsIndex",
  components: {
    MainLayout,
  },
  data() {
    return {
      loading: false,
      results: null,
      sortField: "next_action",
      sortOrder: "asc",
      nextActionRangeAfter: null,
      nextActionRangeBefore: null,
      selectedProductType: null,
      dateRangeAfter: null,
      dateRangeBefore: null,
    }
  },
  methods: {
    async fetch() {
      this.loading = true
      let params = {
        ordering: `${this.sortOrder == "desc" ? "-" : ""}${this.sortField}`,
      }

      if (this.nextActionRangeAfter && this.nextActionRangeBefore) {
        params.next_action_range_after = this.fixDate(
          this.nextActionRangeAfter
        )
        params.next_action_range_before = this.fixDate(
          this.nextActionRangeBefore,
          true
        )
      }
      if (this.dateRangeAfter && this.dateRangeBefore) {
        params.date_range_after = this.fixDate(this.dateRangeAfter)
        params.date_range_before = this.fixDate(this.dateRangeBefore, true)
      }

      this.results = await new MarketingActionProxy(params).all()

      if (this.results.length === 0) {
        this.results = null
        this.$toast.open({
          message: "Nessun risultato trovato",
          type: "is-warning",
        })
      }

      this.loading = false
    },
    clean() {
      this.nextActionRangeAfter = null
      this.nextActionRangeBefore = null
      this.dateRangeAfter = null
      this.dateRangeBefore = null
      this.selectedProductType = null
      this.results = null
    },
    fixDate(date, addOneDay = false) {
      let newDate = new Date(date)
      if (addOneDay) {
        newDate.setDate(newDate.getDate() + 1)
      }
      return newDate.toISOString().substring(0, 10)
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
      this.fetch()
    },
  },
}
</script>
